import { Shell } from "@/components/layout/Shell";
import { useSeo } from "@/hooks/use-seo";

export default function Terms() {
  useSeo({
    title: "Terms of Service | Mychromamind",
    description:
      "Terms and conditions for using Mychromamind — a color psychology entertainment and self-reflection site.",
    path: "/terms",
  });

  return (
    <Shell>
      <div className="max-w-3xl mx-auto px-6 py-12 md:py-24 w-full prose prose-neutral dark:prose-invert">
        <h1 className="font-serif">Terms of Service</h1>
        <p className="text-sm text-muted-foreground">Last updated: July 8, 2026</p>

        <p>
          Welcome to Mychromamind. By accessing or using this site you agree to these terms. Please
          read them carefully before using the site.
        </p>

        <h2>1. About this site</h2>
        <p>
          Mychromamind is an entertainment and self-reflection platform built around color
          psychology. The quizzes, color meanings, and any results or guidance produced by the site
          are for recreational and personal curiosity purposes only. They are not psychological
          assessments, medical diagnoses, legal opinions, financial advice, or professional services
          of any kind.
        </p>

        <h2>2. Acceptable use</h2>
        <p>You agree to use Mychromamind only for lawful purposes. You must not:</p>
        <ul>
          <li>Attempt to disrupt, overload, or compromise the site or its infrastructure.</li>
          <li>Scrape, copy, or reproduce site content for commercial use without written permission.</li>
          <li>Use the site in any way that violates applicable local, national, or international law.</li>
        </ul>

        <h2>3. Intellectual property</h2>
        <p>
          All content on Mychromamind — including text, color descriptions, quiz questions, design,
          and code — is the property of Mychromamind and protected by applicable copyright laws.
          Personal, non-commercial sharing (e.g. sharing a result on social media) is encouraged and
          permitted.
        </p>

        <h2>4. No warranties</h2>
        <p>
          This site is provided "as is" without warranties of any kind, express or implied. We do
          not guarantee that the site will be available at all times, error-free, or that any
          results will be accurate or suitable for any purpose.
        </p>

        <h2>5. Limitation of liability</h2>
        <p>
          To the fullest extent permitted by law, Mychromamind and its operators shall not be liable
          for any direct, indirect, incidental, or consequential damages arising from your use of
          the site or reliance on any content it provides.
        </p>

        <h2>6. Third-party services</h2>
        <p>
          This site may display advertisements served by Google AdSense and may load resources from
          Google Fonts. These third parties have their own privacy and terms policies, which govern
          their services independently of this site.
        </p>

        <h2>7. Changes to these terms</h2>
        <p>
          We may update these terms from time to time. Continued use of the site after changes are
          posted constitutes your acceptance of the revised terms. The "Last updated" date at the
          top of this page will reflect the most recent revision.
        </p>

        <h2>8. Contact</h2>
        <p>
          Questions about these terms? Visit our{" "}
          <a href="/contact" className="underline underline-offset-4 hover:text-primary transition-colors">
            Contact page
          </a>
          .
        </p>
      </div>
    </Shell>
  );
}
